 
import React from "react";
import { StandadCard } from "../../../../../components/Cards";


import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { useCustomerPolicyDetails } from "../../../../../hooks";
import { useOutletContext } from "react-router-dom";
import { HabitationalRiskLocationList } from "./HabitationalRiskLocation/HabitationalRiskLocationList";
import { InterestedPartyList } from "./InterestedParties/InterestedPartiesList";

export const RiskLocationRoot: React.FC = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  const { details } = useCustomerPolicyDetails(customerPolicyId);


  return (
    <PageLoader
      loading={details.loading === LoadState.InProgress}
      error={details.error ? { message: details.error } : null}
    >
      <StandadCard>
        {/* <LabelCard heading="Risk Locations" /> */}
        <HabitationalRiskLocationList
          customerId={customerId}
          customerPolicyId={customerPolicyId}
        />

        {/* <LabelCard heading="Intrested Parties" /> */}
        <InterestedPartyList
            customerId={customerId}
            customerPolicyId={customerPolicyId}
          />
      </StandadCard>
    </PageLoader>
  );
};
